import { render } from "./EmailListingTable.vue?vue&type=template&id=2bd06467&scoped=true"
import script from "./EmailListingTable.vue?vue&type=script&lang=js"
export * from "./EmailListingTable.vue?vue&type=script&lang=js"

import "./EmailListingTable.vue?vue&type=style&index=0&id=2bd06467&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd06467"]])

export default __exports__